<template>
  <div class="swiper-main">
    <div class="title">{{immersiveTourInfo.title}}</div>
    <div class="desc">{{immersiveTourInfo.desc}}</div>
    <div class="swiper-container3-phone1 swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in immersiveTourInfo.contentList" :key="item.id">
          <div class="tab">{{immersiveTourInfo.tabList[item.id - 1].title}}</div>
         <div class="swiper-slide-content">
            <img loading="lazy"  :src="item.img" alt="">
            <div class="swiper-all-content">
              <div class="swiper-slide-title">{{item.title}}</div>
              <div class="swiper-slide-desc">{{item.desc}}</div>
            </div>
         </div>
        </div>
      </div>
      <!-- <div class="next common"><img loading="lazy"  :src="left" alt=""></div>
      <div class="prev common"><img loading="lazy"  :src="right" alt=""></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import immersiveTour from '/js/experience/activities/immersiveTour.js'
export default {
  props:{
    type:Number,
    swiperList:Array,
  },
  data() {
    return {
      swiper: null, // 用于存储 Swiper 实例
      immersiveTourInfo: immersiveTour.immersiveTour,
      // left:left,
      // right:right,
      viewportWidth:0
    };
  },
  created() {
    console.log(this.immersiveTourInfo)
  },
  watch:{
    swiperList(newVal){
      if(this.type == 1){
        if(newVal.length > 0){
          this.adventureList = newVal
        }
      }
    },
    deep:true,
    immediate:true
  },
  mounted() {
    // 初始化 Swiper
    this.swiper = new Swiper('.swiper-container3-phone1', {
      // slidesPerView: 1.2,
      // spaceBetween: 8,
      // nextButton: '.prev',
      // prevButton: '.next',
      // centeredSlides: true, // 中间的幻灯片居中
      loop:true,
      //  pagination: '.swiper-pagination',
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        autoplay: 3000, // 自动播放（ms）
        coverflow: {
            rotate: 40,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows : true
        }
    });
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.swiper-main {
  width: 21.4375rem;
  margin: 2.5rem auto 0;

  .title {
    color: #09080D;
    text-align: center;
    font-family: Butler;
    font-size: 1.375rem;
    font-weight: 700;
    line-height: 150%;
    text-transform: capitalize;
    width: 100%;
  }

  .desc {
    color: #09080D;
    text-align: center;
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    width: 100%;
    margin: 0.375rem 0 1.25rem 0;
  }

  .tab {
    padding: 0.5625rem 1.25rem;
    width: calc(100% - 2.5rem);
    background: #09080D;
    border-radius: 0.125rem;
    color: #FFF;
    text-align: center;
    font-size: 0.875rem;
    font-weight: 600;
    text-transform: capitalize;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 15.625rem;
    height: 100%;
  }

  .swiper-slide img {
    width: 100%;
    height: 8.75rem;
  }

  .swiper-slide-content {
    display: flex;
    flex-direction: column;
  }

  .swiper-all-content {
    height: 8.75rem;
    padding: 0.75rem;
    background: #F4F4F6;
    border-radius: 0 0 0.125rem 0.125rem;

    .swiper-slide-title {
      color: #141418;
      font-feature-settings: 'liga' off, 'clig' off;
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 120%;
      text-transform: capitalize;
    }

    .swiper-slide-desc {
      color: #09080D;
      font-size: 0.75rem;
      font-weight: 300;
      line-height: 150%;
    }
  }
}

</style>
